export const PRODUCTS_PATH = "/products";
